import { useTranslation } from "react-i18next";
import { FormControl, Autocomplete, TextField, useTheme } from "@mui/material";

type Props = {
  label: string;
  items: { value: string; label: string }[];
  value: string;
  setValue: (s: string) => void;
};

const FilterCombobox = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <FormControl variant="outlined">
      <Autocomplete
        value={
          props.value &&
          props.items.find((option) => option.value === props.value)
            ? props.items.find((option) => option.value === props.value)
            : null
        }
        onChange={(event, newValue) =>
          props.setValue(newValue ? newValue.value : "all")
        }
        options={props.items}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("JOBSITE_NAME")}
            InputLabelProps={{
              shrink: true,
              sx: { color: theme.palette.base.label },
            }}
            placeholder={t("ALL")}
            sx={{
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.base.border,
                borderWidth: "2px",
              },
            }}
            InputProps={{
              ...params.InputProps,
              sx: {
                paddingTop: 0,
                paddingBottom: 10,
                borderRadius: 0,
                height: "40px",
                width: "200px",
                display: "flex",
                alignContent: "center",
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default FilterCombobox;
